module.exports = __webpack_public_path__ + "img/logo-small.acafa579.png";